var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from 'react';
import styled from 'react-emotion';
import Hash from 'react-feather/dist/icons/hash';
import { get } from '@utils/theme';
const Icon = styled(Hash) `
  position: absolute;
  display: inline-block;
  top: 6px;
  left: -28px;
  opacity: 0;
  transition: opacity 0.2s;
  color: ${get('colors.primary')};
  cursor: default;
`;
const Heading = styled('h2') `
  position: relative;
  padding-bottom: 5px;
  ${p => p.theme.docz.mq(get('styles.h2')(p))};

  &:hover ${Icon.toString()} {
    opacity: 1;
  }
`;
const Anchor = styled('span') `
  position: absolute;
  top: calc((var(--colorbar-height) + 10px) * -1);
  left: 0;
`;
export const H2 = (_a) => {
    var { children, id } = _a, props = __rest(_a, ["children", "id"]);
    return (React.createElement(Heading, Object.assign({}, props),
        React.createElement(Anchor, { id: id }),
        React.createElement("a", { href: `#${id}`, onClick: (e) => e.preventDefault() },
            React.createElement(Icon, { height: 20 })),
        children));
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSDIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvY29tcG9uZW50cy91aS9IMi50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUEsT0FBTyxLQUFLLEtBQUssTUFBTSxPQUFPLENBQUE7QUFFOUIsT0FBTyxNQUFNLE1BQU0sZUFBZSxDQUFBO0FBQ2xDLE9BQU8sSUFBSSxNQUFNLCtCQUErQixDQUFBO0FBRWhELE9BQU8sRUFBRSxHQUFHLEVBQUUsTUFBTSxjQUFjLENBQUE7QUFFbEMsTUFBTSxJQUFJLEdBQUcsTUFBTSxDQUFDLElBQUksQ0FBQyxDQUFBOzs7Ozs7O1dBT2QsR0FBRyxDQUFDLGdCQUFnQixDQUFDOztDQUUvQixDQUFBO0FBRUQsTUFBTSxPQUFPLEdBQUcsTUFBTSxDQUFDLElBQUksQ0FBQyxDQUFBOzs7SUFHeEIsQ0FBQyxDQUFDLEVBQUUsQ0FBQyxDQUFDLENBQUMsS0FBSyxDQUFDLElBQUksQ0FBQyxFQUFFLENBQUMsR0FBRyxDQUFDLFdBQVcsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDOztZQUVqQyxJQUFJLENBQUMsUUFBUSxFQUFFOzs7Q0FHMUIsQ0FBQTtBQUVELE1BQU0sTUFBTSxHQUFHLE1BQU0sQ0FBQyxNQUFNLENBQUMsQ0FBQTs7OztDQUk1QixDQUFBO0FBRUQsTUFBTSxDQUFDLE1BQU0sRUFBRSxHQUFtQyxDQUFDLEVBSWxELEVBQUUsRUFBRTtRQUo4QyxFQUNqRCxRQUFRLEVBQ1IsRUFBRSxPQUVILEVBREMsc0NBQVE7SUFDSixPQUFBLENBQ0osb0JBQUMsT0FBTyxvQkFBSyxLQUFLO1FBQ2hCLG9CQUFDLE1BQU0sSUFBQyxFQUFFLEVBQUUsRUFBRSxHQUFJO1FBRWxCLDJCQUNFLElBQUksRUFBRSxJQUFJLEVBQUUsRUFBRSxFQUNkLE9BQU8sRUFBRSxDQUFDLENBQTBDLEVBQUUsRUFBRSxDQUN0RCxDQUFDLENBQUMsY0FBYyxFQUFFO1lBR3BCLG9CQUFDLElBQUksSUFBQyxNQUFNLEVBQUUsRUFBRSxHQUFJLENBQ2xCO1FBQ0gsUUFBUSxDQUNELENBQ1gsQ0FBQTtDQUFBLENBQUEifQ==